<template>
  <div class="download">
    <el-link href="https://www.pgyer.com/EUa5TO" target="_blank">安卓下载</el-link>
    <el-link href="https://apps.apple.com/cn/app/sunnyfit/id1574628819" target="_blank">ios下载</el-link>
  </div>
</template>

<script>
export default {
  name: 'Download',
  created () {
    this.getUserAgent()
  },
  methods: {
    getUserAgent () {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isAndroid) {
        window.open('https://www.pgyer.com/EUa5TO', '_self')
      } else if (isIOS) {
        window.open('https://apps.apple.com/cn/app/sunnyfit/id1574628819', '_self')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.download {
  margin: 100px auto;
  ::v-deep {
    .el-link--inner {
      margin: 30px;
    }
  }
}
</style>
